export const PROJECT_LIST_PAGE_TYPE = {
  PORTFOLIO: 'PORTFOLIO'
};
